import styled from 'styled-components';
import { RawButton } from '../../../../../../CommonComponents/OPL/Button/Button.styles';
import { Card } from '../../../../../../CommonComponents/OPL/Card/Card';

export const AlignmentCardButton = styled(RawButton)(({ theme }) => ({
  padding: '0',
  width: '100%',

  '&[data-focus-visible-added]:not(.disabled):focus': {
    outline: 'none',
    boxShadow: `0px 0px 0px 2px ${theme.colors.primary['300']}, inset 0px 0px 0px 1px ${theme.colors.primary['500']}`,
  },
}));

export const AlignmentCard = styled(Card)(({ theme }) => ({
  width: 180,
  height: 208,
  borderRadius: theme.radii.xl,
  padding: '16px 12px',
  textAlign: 'center',
}));
